import { render, staticRenderFns } from "./StatsTotalRating.vue?vue&type=template&id=efe7f0fc&"
import script from "./StatsTotalRating.vue?vue&type=script&lang=js&"
export * from "./StatsTotalRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports